var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({class:{
    'severity-primary': _vm.$props.severity === null,
    'severity-info': _vm.$props.severity === 'info',
    'severity-warn': _vm.$props.severity === 'warn',
    'severity-danger': _vm.$props.severity === 'danger',
    'severity-success': _vm.$props.severity === 'success',
  }},'button',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.$props.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }